import { Component, ComponentRef, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Logger } from '../../../../logging/default-log.service';
import { ApplicationService } from '../../../../service/application.service';
import { DynamicModal } from '../../../modal/dynamic.modal.interface';
import { Subject } from 'rxjs';
import { PendingOrderService } from '../../../../service/pending.order.service';
import { NgClass } from '@angular/common';

/**
 * Retrieve the order comment and shows it in the popup
 *
 * @author Patrick van Zadel
 */
@Component({
    selector: 'add-comment',
    styleUrls: ['add.comment.component.scss'],
    templateUrl: 'add.comment.component.html',
    standalone: true,
    imports: [NgClass, FormsModule, ReactiveFormsModule]
})
export class AddCommentComponent implements OnInit, DynamicModal {
    @Input() data: any;
    addedComment: Subject<boolean> = new Subject();
    commentValue: Subject<string> = new Subject();
    popupOpen: boolean = false;
    commentForm: UntypedFormGroup;
    hasComment: boolean = false;
    _componentRef: ComponentRef<any>;

    constructor(
        private applicationService: ApplicationService,
        private formBuilder: UntypedFormBuilder,
        private pendingOrderService: PendingOrderService,
        private logger: Logger
    ) {
        this.popupOpen = true;
    }

    ngOnInit() {
        this.commentForm = this.formBuilder.group({
            commentText: new UntypedFormControl({
                value: this.data.comment,
                disabled: !this.data.isEditable
            })
        });
    }

    close(saveComment = false): void {
        this.popupOpen = false;

        const body = document.querySelector('body');
        body?.classList.toggle('popupOpen', false);

        setTimeout(() => {
            if (saveComment) {
                this.addedComment.next(true);
                this.commentValue.next(this.commentForm.get('commentText')?.value);
            }

            this._componentRef.destroy();
        }, 400);
    }

    /**
     * Process form submit and notify services
     * @param value
     */
    onSubmit(value: any) {
        if (this.commentForm.valid) {
            const commentValue = this.commentForm.get('commentText')?.value;
            this.pendingOrderService
                .saveComment(commentValue, this.data.webuuid)
                .subscribe(
                    () => {
                        this.close(true);
                    },
                    () => {
                        // failed to save comment, error handling done in service.
                    }
                );
        }

        return false;
    }
}
